export default __webpack_public_path__ + "static/media/site-icon.e35ec120.svg";